<template>
  <v-layout row wrap v-if="is_list_available">
    <v-flex md10 xs4>
    </v-flex>
    <v-flex md2 xs8>
      <v-text-field
        class="mr-3"
        v-model="search"
        :label="$t('rms.search')"
        single-line
        clear-inner-icon="close"
        color="primary"
        @input="getApiData"
        @click:clear="clearSearch"
        hide-details
        clearable
        outline
      ></v-text-field>
    </v-flex>
    <v-flex xs12>
      <ScreenerList :list="archiveList.data" :is_past="true"></ScreenerList>
    </v-flex>
    <v-flex xs12 v-if="archiveList.data && archiveList.data.length && total > 1">
      <div class="text-xs-center mb-4">
        <v-pagination
          v-model="page"
          :length="total"
          :total-visible="7"
        ></v-pagination>
      </div>
    </v-flex>
  </v-layout>
</template>

<script>
import {mapState} from 'vuex';
import ScreenerList from '@/components/screener/List';
export default {
  name: 'ScreenerToday',
  metaInfo() {
    return {
      title: 'Screeners',
    };
  },
  components: {
    ScreenerList,
  },
  data: () => ({
    is_list_available: false,
    page: 1,
    perPage:20,
    search:""
  }),

  computed: {
    ...mapState({
      archiveList: (state) => state.screening.archiveList,
    }),
    total: function() {
      return this.archiveList.last_page;
    },
  },
  watch: {
    archiveList() {
      this.is_list_available = true;
    },
    page: {
      handler: 'getApiData',
      deep: true,
    },
  },

  created() {
    this.getApiData();
  },
  methods: {
    clearSearch() {
        this.search = "";
        this.getApiData();
    },
    async getApiData() {
      try {
        this.$store.dispatch('screening/archiveList', {
          page: this.page,
          perPage: this.perPage,
          search: this.search
        });
      } catch (error) {
        this.$store.dispatch('app/showMessage', {
          message: error.message,
          color: 'error',
        });
      }
    },
  },
};
</script>
